<template>
  <v-dialog :value="value" max-width="400" persistent @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="text-left"> {{ bodyTitle }}</v-card-title>
      <v-card-text class="text-left">{{ bodyText }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <Button text color="brandPrimary" @click="$emit('stay')">
          {{ stayLabel }}
        </Button>
        <Button text color="red" :loading="loading" @click="$emit('discard')">
          {{ discardLabel }}
        </Button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Button from "@/components/generic/Button.vue";

export default {
  name: "UnsavedChangesDialog",
  components: { Button },
  props: {
    value: { type: Boolean, default: false },
    bodyTitle: {
      type: String,
      default: "Are you sure you want to exit?",
    },
    bodyText: {
      type: String,
      default: "You will lose any unsaved changes.",
    },
    stayLabel: { type: String, default: "Nevermind" },
    discardLabel: { type: String, default: "Yes, Cancel" },
    loading: { type: Boolean, default: false },
  },
};
</script>
